import LicensePeriod from './LicensePeriod';

export default LicensePeriod;